export const gender_pet = [
  { value: "MALE", name: "Macho" },
  { value: "FEMALE", name: "Hembra" },
];

export const generic_data_check_box = [
  { value: "true", name: "Si" },
  { value: "false", name: "No" },
];

export const size_pet = [
  { value: "EXTRA_SMALL", name: "0-5 kg. Extra Pequeño" },
  { value: "SMALL", name: "5-10 kg. Pequeño" },
  { value: "MEDIUM", name: "10-20 kg. Mediano" },
  { value: "LARGE", name: "20-40 kg. Grande" },
  { value: "GIANT", name: "+40 kg. Gigante" },
];
